// extracted by mini-css-extract-plugin
export default {"container":"TagFormModal_container__3+hCK","tagIconCenter":"TagFormModal_tagIconCenter__bmum2","warning":"TagFormModal_warning__37pPS"};